import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA3FXg5s9uNz0oa7vVyT-7mAVRD_rwZJDg",
  authDomain: "landing-page-4151f.firebaseapp.com",
  projectId: "landing-page-4151f",
  storageBucket: "landing-page-4151f.appspot.com",
  messagingSenderId: "419903610393",
  appId: "1:419903610393:web:921c3eab0431ffc04e5488",
  measurementId: "G-PVL4CJ2CW2"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

// ✅ Set localStorage persistence
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Persistence set to localStorage");
  })
  .catch((error) => {
    console.error("Persistence error:", error);
  });

const db = getFirestore(app);

export { auth, db, RecaptchaVerifier, signInWithPhoneNumber };
